import React from 'react';
import {Link} from 'react-router-dom';
import './buttons.css';
import {PriceFormat} from "../../../../../utils/utils";
import API from "../../../../../utils/api";
import SocialShare from "../../social-share";
import Spinner from "../../../../../utils/spinner";

import favClickedIcon from '../icons/favoritesRed.svg';
import favDefaultIcon from '../icons/favoritesGray.svg';
import certIcon from '../icons/cert.svg';

class HeaderButtons extends React.Component {
    constructor (props) {
        super();

        this.state = {
            loading: false,
            moderationDone: false
        };
    }

    renderViewButton = () => {
        const t = this;
        const {data, progress} = t.props;

        if (progress) {
            return <Link to={'/course/' + data.slug + '/' + progress.file_index}><button className="v2">Продолжить</button></Link>;
        }

        if (!data.lessons || !data.lessons[0]) {
            return '';
        }

        return <Link to={'/course/' + data.slug + '/' + data.lessons[0].id}><button className="v2">Смотреть</button></Link>;
    };

    moderateHide = () => {
        const t = this;
        const {data} = t.props;
        t.setState({loading: true});
        API.delete('/whub/v3/moderate/course/' + data.id)
            .then(function (r) {
                t.setState({loading: false, moderationDone: true});
                alert('Курс переведен в черновики!')
            })
            .catch(function (error) {
                t.setState({loading: false});
                alert(error)
            });
    };

    handlePurchaseClick = () => {
        const t = this;
        const {data, onPurchase} = t.props;

        t.setState({loading: true});

        onPurchase(data, () => {
            t.setState({loading: false});
        });
    };

    render() {
        const t = this;
        const {loading, moderationDone} = t.state;
        const {
            data,
            userData,
            isOwner,
            scrollToContent,
            authorized,
            handleGift,
            handleReport,
            handleEntry,
            cancelEntry,
            handleFavourite
        } = t.props;

        const purchased = userData.purchased || [];
        const isPurchased = purchased.indexOf(data.id) > -1;

        const subscriptions = userData.subscriptions || {};
        const entries = subscriptions.courses || [];
        const hasEntry = entries.indexOf(data.id) > -1;

        const hasDiscount = !!parseInt(data.discount_amount_percentage);
        const price = hasDiscount ? data.price : data.regular_price;
        const isFree = !price;
        const isSchool = authorized && userData.role === 'school';
        const isTester = isSchool && userData.tester;
        const isAdmin = userData.role === 'administrator';

        const discountText = hasDiscount ? <div className="discount_text">Со скидкой {data.discount_amount_percentage} %</div> : '';
        const actualPrice = isFree ? 'Бесплатно' : PriceFormat(parseInt(Math.ceil(price))) + ' ₽';
        const regularPriceBlock = hasDiscount ? <div className="regular_price_block">
            <p>Стоимость без скидки</p>
            <span>{PriceFormat(parseInt(Math.ceil(data.regular_price)))} ₽</span>
        </div> : '';

        let purchaseText = '';

        if (isPurchased) {
            purchaseText = 'В моих курсах';
        }
        else {
            if (isFree) {
                purchaseText = 'В мои курсы'
            }
            else {
                purchaseText = 'Купить';
            }
        }

        const meta = data.meta ? data.meta : {};
        const onlineCourseStatus = meta.online_course_status || {};
        const dateNow = new Date();
        const sellsStartDate = onlineCourseStatus.sell_starts_date || 0;
        const sellsStarted = dateNow.getTime() >= sellsStartDate;

        const isOnlineCourse = meta.date_start && parseInt(meta.date_start) !== 0;
        const isAvailableForEntry = onlineCourseStatus.available_for_entry ? onlineCourseStatus.available_for_entry : false;
        const hasSellsStarts = isOnlineCourse && onlineCourseStatus.sell_starts_date && parseInt(onlineCourseStatus.sell_starts_date) > 0;

        const btnPurchase = !isSchool && !isPurchased && (!hasSellsStarts || sellsStarted) ? <button onClick={t.handlePurchaseClick} className="v2">{purchaseText}</button> : '';
        const btnEntry = !isSchool && !isPurchased && !hasEntry && isAvailableForEntry && !sellsStarted ? <button onClick={handleEntry} className="v2">Записаться</button> : '';

        const btnCancelEntry = !isSchool && !isPurchased && isOnlineCourse && hasEntry ? <button onClick={cancelEntry} className="v2">Отписаться</button> : '';


        const btnGift = !isFree && authorized && !isSchool ? <button onClick={handleGift} className="v2">Подарить</button> : '';

        const btnView = isPurchased ? t.renderViewButton() : '';

        const isFavourited = userData.favourites && userData.favourites.length > 0 && userData.favourites.indexOf(data.id) > -1;
        // const favouriteText = isFavourited ? 'В избранном' : 'В избранное';
        const favouriteIcon = isFavourited ? favClickedIcon : favDefaultIcon ;
        // const cls_favourited = isFavourited ? 'favourited' : '';
        // const btnFavourite = !isSchool ? <span onClick={handleFavourite} className={'favourite_link ' + cls_favourited}>{favouriteText}</span> : '';

        const btnEdit = isOwner || isAdmin ? <Link to={'/course/' + data.id + '/edit/general'}><button className="v2 btn_edit">Редактировать</button></Link> : '';

        const btnModerate = isTester && !isOwner && !moderationDone ? <button onClick={t.moderateHide} className="v2 btn_moderate red">Скрыть курс</button> : '';

        const schoolText = isSchool && !isOwner ? <p className="school_text">К сожалению, покупка курсов для школ пока недоступна!</p> : '';

        const certBlock = data.certificate_available ? <div className="cert_block">
          <img alt="" src={certIcon}></img>
          <span>Сертификат W-HUB</span>
        </div> : ""


        return (
            <div className="header_buttons">
                {/* {btnFavourite} */}
                {certBlock}
                <div className="header_top">
                  <div onClick={handleFavourite} className="favorites_block">
                    <img alt="" src={favouriteIcon} />
                  </div>
                  <div className="share_holder">
                    <SocialShare />
                  </div>
                </div>
                <div className="price_block">
                    {discountText}
                    <div className="actual_price">{actualPrice}</div>
                    {regularPriceBlock}
                </div>
                {btnView}
                {btnPurchase}
                {btnEntry}
                {btnCancelEntry}
                {btnGift}
                {btnEdit}
                {btnModerate}
                {schoolText}
                <button onClick={scrollToContent} className="v2 light">Программа</button>
                <div className="report_link_wrapper">
                    <span onClick={handleReport} className="report_link">Пожаловаться</span>
                </div>
                <Spinner show={loading} />
            </div>
        );
    }
}

export default HeaderButtons;
